<script>
//Deprecate this as we now have better more readable manners of achieving the same.
import RegistrationCategorySelect from "./RegistrationCategorySelect.vue";
import VSelect from "@alfsnd/vue-bootstrap-select";
import SkuSelect from "./SkuSelect.vue";
import FulfilmentMethodPicker from "../Orders/FulfilmentMethodPicker.vue";

export default {
    name: "GetEntitiesByForeignKeyId",
    inject: ['$validator'],
    components: {
        RegistrationCategorySelect,
        SkuSelect,
        VSelect,
        FulfilmentMethodPicker,
    },
    props: {
        defaultId: {
            default: null,
            required: false,
            type: Number,
        },

        endPointPartOne: {
            required: true,
            type: String,
        },

        endPointPartTwo: {
            default: '',
            required: false,
            type: String,
        },

        fields: {
            default: () => ([]),
            required: false,
            type: Array,
        },
        fieldElType: {
            default: 'fixed',
            type: String
        },
        componentKey: 0
    },

    data() {
        return {
            entities: [],
            selected: this.fieldElType == 'fixed' ? (this.defaultId !== null  ? this.defaultId : "") : "", //Object - Refactor this so that's its common between the clerk/participants and modal/transfer
            id: this.defaultId ? this.defaultId : ""//Number
        }
    },

    watch: {
        selected(selected) {
            if (this.fieldElType == 'searchable') {
                this.id = selected.value;
                this.getEntities(selected.value);
            } else {
                this.id = selected;
                this.getEntities(selected);
            }
        },
        id(newVal, oldVal) {
            if (newVal == 0) {
                this.id = "";
            }
        }
    },

    methods: {
        getEntities(id) {
            let params = this.fields.length
                ? { fields: this.fields }
                : {};
            axios
                .get(`${this.endPointPartOne}${id}${this.endPointPartTwo}`, {
                    params,
                })
                .then(response => Object.assign(this, {entities: response.data.data}))
                .catch(error => console.log(error))
            ;
        },
        clear() {
            this.selected = "";
            this.componentKey = this.componentKey + 1;
        }
    },

    created() {
        if (this.id) {
            this.getEntities(this.id);
        }
    },
    validateState(ref) {
        if (
            this.vFields[ref] &&
            (this.vFields[ref].dirty || this.vFields[ref].validated)
        ) {
            return !this.vErrors.has(ref);
        }
        return null;
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/GetEntitiesByForeignKeyId.vue